import axios from "axios"
import { FETCH_USERS_FAILED, FETCH_USERS_REQUESTED, FETCH_USERS_SUCCEEDED, UPDATE_CURRENT_PAGE, UPDATE_SORT_BY } from "../constants"
import Cookies from 'js-cookie'

const fetchRestaurantsRequest = () => {
    return {
        type: FETCH_USERS_REQUESTED
    }
}

const fetchRestaurantsSuccess = payload => {
    return {
        type: FETCH_USERS_SUCCEEDED,
        payload: payload
    }
}

const fetchRestaurantsFailure = payload => {
    return {
        type: FETCH_USERS_FAILED,
        payload: payload
    }
}

export const updateFilterOptions = payload => {
    return {
        type: UPDATE_SORT_BY,
        payload: payload
    }
}

export const updatePageNumber = payload => {
    return {
        type: UPDATE_CURRENT_PAGE,
        payload: payload
    }
}

export const fetchRestaurants = (payload) => {
    return function (dispatch) {
        dispatch(fetchRestaurantsRequest());
        const jwtToken = Cookies.get("jwt_token");
        let url = `https://apis.ccbp.in/restaurants-list?offset=${payload.offset}&limit=${payload.limit}&sort_by_rating=${payload.sortBy}`
        axios
            .get(url,
                {
                    'headers':
                    {
                        Authorization: `Bearer ${jwtToken}`,
                    },
                }
            )
            .then(response => {
                // response.data is the users
                dispatch(fetchRestaurantsSuccess({ restaurants: response.data.restaurants, totalCount: response.data.total }))
            })
            .catch(error => {
                // error.message is the error message
                dispatch(fetchRestaurantsFailure(error.message))
            })
    }
} 